/**
 * Identity and E2E types.
 */
/** Crypto profile currently accepted on the wire. */
export const SHIPPED_CRYPTO_PROFILE = 'default';
/**
 * True when a wire `cryptoProfile` / `preferredCryptoProfile` is present
 * and is not the shipped profile. Missing/undefined is treated as default.
 */
export function isUnshippedCryptoProfile(profile) {
    return typeof profile === 'string' && profile !== SHIPPED_CRYPTO_PROFILE;
}
/**
 * Who may send this identity a direct Space invite. Independent values;
 * `anyone` overrides the others.
 */
export const SPACE_INVITE_SOURCES = ['friends', 'spaceMembers', 'anyone'];
/** When `allowSpaceInvitesFrom` is omitted, only friends may send a direct Space invite. */
export const DEFAULT_ALLOW_SPACE_INVITES_FROM = ['friends'];
export function isSpaceInviteSource(value) {
    return value === 'friends' || value === 'spaceMembers' || value === 'anyone';
}
/** Drop unknown entries and keep a stable order. Empty means nobody. */
export function normalizeAllowSpaceInvitesFrom(sources) {
    const seen = new Set();
    for (const source of sources) {
        if (isSpaceInviteSource(source))
            seen.add(source);
    }
    return SPACE_INVITE_SOURCES.filter((source) => seen.has(source));
}
/** Treat a missing field as {@link DEFAULT_ALLOW_SPACE_INVITES_FROM}; keep `[]` as nobody. */
export function resolveAllowSpaceInvitesFrom(sources) {
    if (sources == null)
        return [...DEFAULT_ALLOW_SPACE_INVITES_FROM];
    return normalizeAllowSpaceInvitesFrom(sources);
}
export function withSpaceInviteSource(current, source, enabled) {
    const next = new Set(resolveAllowSpaceInvitesFrom(current));
    if (enabled)
        next.add(source);
    else
        next.delete(source);
    return SPACE_INVITE_SOURCES.filter((value) => next.has(value));
}
export function allowsSpaceInviteFrom(sources, relation) {
    const resolved = resolveAllowSpaceInvitesFrom(sources);
    if (resolved.includes('anyone'))
        return true;
    if (resolved.includes('friends') && relation.isFriend)
        return true;
    if (resolved.includes('spaceMembers') && relation.sharesSpace)
        return true;
    return false;
}
//# sourceMappingURL=identity-types.js.map